import axios from "axios";
import Vue from "vue";
import { ir } from "../../../../../check_domain_ir";

const API_BASE =
  Vue.prototype.$coreApi2 || ir("https://api.terminalads.com/api");
const coreApi3 = Vue.prototype.$coreApi3;

let id_token = localStorage.getItem("id_token");

const axiosGuideContent = axios.create({
  baseURL: API_BASE,
  timeout: 150000,
  headers: {
    Authorization: id_token ? `Bearer ${id_token}` : undefined,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

function geturl(uri) {
  return `${API_BASE}/${uri}`;
}

function getAuthHeaders() {
  return {
    Authorization: id_token ? `Bearer ${id_token}` : undefined,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
}

// ----------------------------------------------------
// متغیر کش برای ذخیره درخواست‌های GetFile
const getFileCache = {};

// تابعی برای پاک کردن کش هنگام ویرایش یا حذف اطلاعات
function clearFileCache(servicename = null) {
  if (servicename) {
    delete getFileCache[servicename];
  } else {
    for (let key in getFileCache) {
      delete getFileCache[key];
    }
  }
}
// ----------------------------------------------------

function GetServices(queries = {}) {
  return new Promise((resolve, reject) => {
    axiosGuideContent
      .get("getServices", { headers: getAuthHeaders(), params: queries })
      .then(({ data }) => {
        if (data && Array.isArray(data.services)) {
          const filterData = data.services.map((item) => ({
            id: item.id,
            name: item.nameLand || "نام نامشخص",
          }));
          resolve(filterData);
        } else {
          console.error("خطا در دریافت داده ها", data);
          resolve([]);
        }
      })
      .catch((error) => {
        console.error("خطا در دریافت از  سرور", error.response || error);
        reject(error.response || error);
      });
  });
}

function GetCategories(service_id) {
  return new Promise((resolve, reject) => {
    axios
      .get(geturl(`category/get-all`), {
        headers: getAuthHeaders(),
        params: { sid: service_id, length: 10000 },
      })
      .then(({ data }) => {
        if (data && data.data) {
          const filterData = data.data
            .filter((p) => p.service_id === service_id)
            .map((p) => ({
              id: p.id,
              name: p.name,
              slug: p.slug,
            }));

          resolve(filterData);
        } else {
          console.log("خطا در دریافت داده از سرور برای دسته بندی و سرویس");
          resolve([]);
        }
      })
      .catch(({ response }) => {
        console.log("خطا در دریافت از سرور", response);
        reject(response);
      });
  });
}

function GetFile(servicename) {
  // ۱. اگر درخواست قبلاً انجام شده یا در حال انجام است، همان را برگردان
  if (getFileCache[servicename]) {
    return getFileCache[servicename];
  }

  // ۲. در غیر این صورت، درخواست جدید بساز
  const request = new Promise((resolve, reject) => {
    axios
      .get(geturl(`service/file`), {
        headers: getAuthHeaders(),
        params: { name: servicename },
      })
      .then(({ data }) => {
        if (Array.isArray(data)) resolve(data);
        else {
          console.error("فرمت فایل دریافتی درست نیست", data);
          resolve([]);
        }
      })
      .catch((error) => {
        const message = error.response
          ? `Server error ${error.response.status}: ${error.response.data}`
          : error.message || "Network error (possibly CORS)";
        console.error("Response Error:", message);
        
        // ۳. اگر خطا داد، کش را پاک کن تا در درخواست بعدی مجدداً تلاش کند
        delete getFileCache[servicename];
        reject(error);
      });
  });

  // ۴. ذخیره درخواست در کش
  getFileCache[servicename] = request;

  return request;
}

function getContentType(url) {
  const path = url.split(/[?#]/)[0];
  const extensionMatch = path.match(/\.([0-9a-z]+)$/i);
  const extension = extensionMatch ? extensionMatch[1].toLowerCase() : "";

  const mimeTypes = {
    mp3: "audio/mpeg",
    wav: "audio/wav",
    aac: "audio/aac",
    flac: "audio/flac",
    ogg: "audio/ogg",
    mp4: "video/mp4",
    webm: "video/webm",
    avi: "video/x-msvideo",
    mkv: "video/x-matroska",
    ogv: "video/ogg",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    bmp: "image/bmp",
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    csv: "text/csv",
    txt: "text/plain",
    zip: "application/zip",
    rar: "application/vnd.rar",
  };

  const mimeType = mimeTypes[extension];
  if (mimeType) {
    return mimeType;
  }

  console.warn(`Unrecognized extension '${extension}' for ${url}`);
  return "unknown";
}

function GetFile1(servicename) {
  return fetch(`${coreApi3}/storage/services/${servicename}.json`)
    .then((response) => {
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then((data) => {
      if (Array.isArray(data)) return data;
      console.error("فرمت فایل دریافتی درست نیست", data);
      return [];
    })
    .catch((error) => {
      console.error("Response Error:", error.message || error);
      throw error;
    });
}

function GetAllGuideContent(
  id,
  search = "",
  length = 2,
  page = 1,
  perpage = 10,
  dir = "desc"
) {
  return new Promise((resolve, reject) => {
    axios
      .get(geturl(`guideContent`), {
        headers: getAuthHeaders(),
        params: {
          search: search,
          length: length,
          perpage: perpage,
          column: "id",
          dir: dir,
          page: page,
          sid: id,
        },
      })
      .then(({ data }) => {
        if (data && data.data.data && Array.isArray(data.data.data)) {
          const filterData = data.data.data
            .filter((p) => p.service_id === id)
            .map((p) => ({
              id: p.id,
              name: p.name,
              title: p.title,
              text: p.text,
              service_id: p.service_id,
              category_id: p.category_id,
              link: p.link,
              extras: p.extras,
              created_at: p.created_at,
              updated_at: p.updated_at,
            }));
          const result = {
            data: filterData,
            total: data.data.total,
          };
          resolve(result);
        } else {
          console.log("داده‌های مورد انتظار از سرور دریافت نشد");
          resolve([]);
        }
      })
      .catch(({ response }) => {
        console.log("خطا در دریافت از سرور", response);
        reject(response);
      });
  });
}

function AddButtonInfo(data = {}, queries = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(geturl(`guideContent/store`), data, {
        headers: getAuthHeaders(),
        params: queries,
      })
      .then((data) => {
        resolve(data);
      })
      .catch((response) => {
        reject(response);
      });
  });
}

function EditButtonInfo(id, data = {}, queries = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(geturl(`guideContent/update/${id}`), data, {
        headers: getAuthHeaders(),
        params: queries,
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response }) => {
        console.log("خطا در دزیافت اطلاعات از سرور");
        reject(response);
      });
  });
}

function DeleteButtonInfo(id, queries = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(geturl(`guideContent/delete/${id}`), {
        headers: getAuthHeaders(),
        params: queries,
      })
      .then((data) => {
        resolve(data);
      })
      .catch((response) => {
        reject(response);
      });
  });
}

function GetButtonInfoById(id, queries = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(geturl(`guideContent/show/${id}`), {
        headers: getAuthHeaders(),
        params: queries,
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((response) => {
        console.log("خطا در دریافت اطلاعات از سرور", response);
        reject(response);
      });
  });
}

export {
  GetAllGuideContent,
  GetButtonInfoById,
  GetCategories,
  GetFile,
  GetFile1,
  GetServices,
  EditButtonInfo,
  DeleteButtonInfo,
  AddButtonInfo,
  getContentType,
  clearFileCache, 
  
};
